module.exports = __webpack_public_path__ + "img/25b9b823a7f34006932a7d11a0ab005b-1440.94e0e793.png";